import React, {useState} from 'react';
import {FormWrapper} from 'COMPONENTS/pages-components/common/FormWrapper/FormWrapper';
import css from '../GetInTouch/GetInTouch.module.scss'

import {classNames} from 'a-utils';
import {SimpleLink} from 'COMPONENTS/content/links/SimpleLink';
import {Form} from 'COMPONENTS/ui/form/Form';
import {GetInTouchImg, RadioItems} from 'TYPES/types';
import {Input} from 'COMPONENTS/ui/form/input/Input';
import {Radio} from 'COMPONENTS/ui/form/radio/Radio';
import {Button} from 'COMPONENTS/pages-components/common/Button/Button';

import {FormResponse, FormState} from 'COMPONENTS/ui/form/form-utils';
import {InputFile} from 'COMPONENTS/ui/form/file/File';
import {ErrorModal} from 'COMPONENTS/pages-components/common/ErrorModal/ErrorModal';
import {SquirrelVideo} from 'COMPONENTS/pages-components/common/SquirrelVideo/SquirrelVideo';

export type Props = {
  api: string;
  title?: string;
  fields?: {
    name?: string;
    email?: string;
    phone?: string;
    textarea?: string;
    file?: string;
  }
  vacancyId?: string;
  radio?: RadioItems;
  imagePath?: GetInTouchImg;
  type?:string;
}

export const VacancyForm = ({api, title, fields, radio, imagePath, vacancyId, type}: Props) => {
  const [successMessage, showSuccessMessage] = useState(false);
  const [errorMessage, showErrorMessage] = useState(false);


  const onSuccess = (response: FormResponse) => {
    if (response.status === 'success') {
      showSuccessMessage(true);
    }
  }

  const onError = () => {
    showErrorMessage(true);
  }

  const onBeforeSubmit = (state: FormState) => {
    return state;
  }

  // TODO сделать пересчет высоты плавненько
  if (successMessage) {
    return (
      <FormWrapper
        title={`Thanks! Your application has been sent`}
        modifier={`success`}
      >
        <p>We will definitely contact you as soon as possible</p>
      </FormWrapper>
    )
  }

  if (errorMessage) {
    return (
      <ErrorModal/>
    )
  }

  return (
    <section className={classNames(css.main)}>
      <div className={'container'}>
        <div className={css.wrap}>
          <div className={css.text}>
            <h3 className={css.title}>Work with us</h3>
            <p className={css.subtext}>
              Hey! Our open roles have moved to the Tripledot Studios website.
              <br />
              To find Belka Games positions, just select Belka Games in the “All&nbsp;studios” filter.
            </p>
            <Button isExternal={true} className={css.btn} text="GO TO TRIPLEDOT" link="https://tripledotstudios.pinpointhq.com/" />

          </div>
          <div className={css.image}>
            {imagePath &&
              <SquirrelVideo className={css.video} name={imagePath}/>}
          </div>
        </div>
      </div>
    </section>
  );
};
